
import React from 'react';
import { TextField, InputAdornment, IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const QuantityNumberInput = ({
    value,
    onChange,
    min = 0,
    max = 500,
    step = 1,
    label,
    required = false,
}) => {
    // Ensure the value is a valid number
    const currentValue = isNaN(value) ? min : value;

    const handleIncrease = () => {
        onChange(Math.min(currentValue + step, max)); // Ensure value does not exceed max
    };

    const handleDecrease = () => {
        onChange(Math.max(currentValue - step, min)); // Ensure value does not go below min
    };

    const handleInputChange = (event) => {

        if (event.target.value === "") {
            onChange(0); //Pass default value to indicate the input is cleared
            return;
        };

        // Parse the input value
        const newValue = parseInt(event.target.value, 10);

        // Update only if the new value is a valid number and within range
        if (!isNaN(newValue) && newValue >= min && newValue <= max) {
            onChange(newValue);
        }
    };

    return (
        <>
            <Typography variant="labelSm" color={"text.primary"} component={"label"}>
                {label}
                {required && (
                    <Typography component={"span"} color={"error"}>
                        *
                    </Typography>
                )}
            </Typography>
            <TextField
                value={currentValue}
                onChange={handleInputChange}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <IconButton onClick={handleDecrease} edge="start" disabled={currentValue <= min}>
                                <RemoveIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={handleIncrease} edge="end" disabled={currentValue >= max}>
                                <AddIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                variant="outlined"
                size="small"
            />
        </>
    );
};

export default QuantityNumberInput;
